import { useCurrenciesStore } from '@/entities/currency';

import { VabsPaymentDirection } from '@/shared/api';
import { useQueryPagination } from '@/shared/lib';

import { vabsPaymentsQuery } from '../api';
import { serializePayment } from '../lib/serialize';
import { useQueryClient } from '@tanstack/react-query';

export const usePaymentsController = (enabled: boolean) => {
  const currencies = useCurrenciesStore((state) => state.currenciesById);
  const queryClient = useQueryClient()
  const refetchTxs = async () => {await queryClient.invalidateQueries({queryKey: ['payments-list']}); await queryClient.invalidateQueries({queryKey: ['txs-list']})}
  const {
    data: payments,
    onSearch,
    isLoading: isPaymentsLoading,
    ...pagination
  } = useQueryPagination({
    queryKey: 'payments-list',
    queryFn: vabsPaymentsQuery,
    enabled: enabled,
    serialize: (payments) =>
      payments.reduce<IPaymentTemplate[]>(
        (acc, p) =>
          p.direction === VabsPaymentDirection.Outgoing
            ? [...acc, serializePayment(p, currencies)]
            : acc,
        [],
      ),
  });

  const {
    data: favorites,
    onSearch: onFavSearch,
    isLoading: isFavoritesLoading,
    ...favePagination
  } = useQueryPagination({
    queryKey: 'faves-list',
    enabled: enabled,
    queryFn: (params) => vabsPaymentsQuery({ ...params, isFavorite: true }),
    serialize: (payments) =>
      payments.map((i) => serializePayment(i, currencies)),
  });

  const isLoading = isPaymentsLoading;
  return {
    refetchTxs,
    isLoading,
    isFavoritesLoading,
    onSearch,
    onFavSearch,
    favorites,
    payments,
    pagination,
    favePagination,
  };
};
